module.exports = __webpack_public_path__ + "media/images/extra_functions_bg-b806ad76.png";